/* =============================================
   SPEKTRA DIAMOND — Wishlist System
   localStorage tabanlı, sunucu gerektirmez
   ============================================= */

class SpektraWishlist {
  constructor() {
    this.storageKey = 'spektra_wishlist';
    this.items = this.load();
    this.drawer = null;
    this.overlay = null;
    this.init();
  }

  /* ---------- Storage ---------- */
  load() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey)) || [];
    } catch {
      return [];
    }
  }

  save() {
    localStorage.setItem(this.storageKey, JSON.stringify(this.items));
  }

  has(id) {
    return this.items.some(item => item.id === id);
  }

  add(product) {
    if (!this.has(product.id)) {
      this.items.push(product);
      this.save();
      this.onUpdate();
    }
  }

  remove(id) {
    this.items = this.items.filter(item => item.id !== id);
    this.save();
    this.onUpdate();
  }

  toggle(product) {
    if (this.has(product.id)) {
      this.remove(product.id);
      return false;
    } else {
      this.add(product);
      return true;
    }
  }

  /* ---------- Init ---------- */
  init() {
    document.addEventListener('DOMContentLoaded', () => {
      this.drawer = document.getElementById('wishlist-drawer');
      this.overlay = document.getElementById('wishlist-overlay');

      if (!this.drawer) this.buildDrawer();

      this.bindDrawerTrigger();
      this.bindOverlayClose();
      this.updateBadge();
      this.updatePageButtons();
      this.renderItems();
    });
  }

  /* ---------- Drawer DOM ---------- */
  buildDrawer() {
    const overlay = document.createElement('div');
    overlay.id = 'wishlist-overlay';
    overlay.className = 'wishlist-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    document.body.appendChild(overlay);

    const drawer = document.createElement('div');
    drawer.id = 'wishlist-drawer';
    drawer.className = 'wishlist-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Favoriler');
    drawer.innerHTML = `
      <div class="wishlist-drawer__header">
        <div style="display:flex;align-items:center;gap:0.75rem;">
          <span class="wishlist-drawer__title">Favoriler</span>
          <span class="wishlist-drawer__count" id="wishlist-drawer-count"></span>
        </div>
        <button class="wishlist-drawer__close" id="wishlist-drawer-close" aria-label="Kapat">
          <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
            <path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"/>
          </svg>
        </button>
      </div>
      <div class="wishlist-drawer__body" id="wishlist-drawer-body"></div>
    `;
    document.body.appendChild(drawer);

    this.drawer = drawer;
    this.overlay = overlay;

    document.getElementById('wishlist-drawer-close').addEventListener('click', () => this.closeDrawer());
    overlay.addEventListener('click', () => this.closeDrawer());
  }

  /* ---------- Drawer open/close ---------- */
  openDrawer() {
    this.renderItems();
    this.drawer.classList.add('is-open');
    this.overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.drawer.setAttribute('aria-hidden', 'false');
  }

  closeDrawer() {
    this.drawer.classList.remove('is-open');
    this.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    this.drawer.setAttribute('aria-hidden', 'true');
  }

  bindDrawerTrigger() {
    const trigger = document.getElementById('wishlist-trigger');
    if (trigger) {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.openDrawer();
      });
    }
  }

  bindOverlayClose() {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.closeDrawer();
    });
  }

  /* ---------- Render items ---------- */
  renderItems() {
    const body = document.getElementById('wishlist-drawer-body');
    const countEl = document.getElementById('wishlist-drawer-count');
    if (!body) return;

    const count = this.items.length;
    if (countEl) countEl.textContent = count > 0 ? `(${count})` : '';

    if (count === 0) {
      body.innerHTML = `
        <div class="wishlist-drawer__empty">
          <svg width="48" height="48" fill="none" viewBox="0 0 24 24">
            <path d="M12 21C12 21 3 14.5 3 8.5C3 5.42 5.42 3 8.5 3C10.24 3 11.91 3.81 13 5.08C14.09 3.81 15.76 3 17.5 3C20.58 3 23 5.42 23 8.5C23 14.5 12 21 12 21Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <p>Henüz favori ürün eklemediniz.</p>
          <a href="/collections/all">Koleksiyonları Keşfet</a>
        </div>
      `;
      return;
    }

    body.innerHTML = this.items.map(item => `
      <div class="wishlist-item" data-id="${item.id}">
        <a href="${item.url}" class="wishlist-item__image">
          <img src="${item.image}" alt="${item.title}" loading="lazy" width="90" height="90">
        </a>
        <div class="wishlist-item__info">
          <div>
            <a href="${item.url}" class="wishlist-item__title">${item.title}</a>
            <p class="wishlist-item__price">${item.price}</p>
          </div>
          <div class="wishlist-item__actions">
           <button class="wishlist-item__add-to-cart" onclick="wishlistAddToCart(${item.variantId || ''}, this)">Sepete At</button>
<a href="${item.url}" class="wishlist-item__view-btn">Ürünü Görüntüle</a>
          </div>
        </div>
        <button class="wishlist-item__remove" data-remove="${item.id}" aria-label="Favorilerden çıkar">
          <svg width="10" height="10" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5"><path d="M18 6L6 18M6 6l12 12" stroke-linecap="round"/></svg>
        </button>
      </div>
    `).join('');

    body.querySelectorAll('[data-remove]').forEach(btn => {
      btn.addEventListener('click', () => {
        const id = parseInt(btn.dataset.remove);
        this.remove(id);
        this.renderItems();
      });
    });
  }

  /* ---------- Badge ---------- */
  updateBadge() {
    const badge = document.getElementById('wishlist-badge');
    if (!badge) return;
    const count = this.items.length;
    badge.textContent = count;
    badge.classList.toggle('is-visible', count > 0);
  }

  /* ---------- Page buttons ---------- */
  updatePageButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const id = parseInt(btn.dataset.wishlistBtn);
      btn.classList.toggle('is-active', this.has(id));
    });
  }

  /* ---------- On update ---------- */
  onUpdate() {
    this.updateBadge();
    this.updatePageButtons();
  }
}

/* Global instance */
window.spektraWishlist = new SpektraWishlist();

/* Product page button handler */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('[data-wishlist-btn]');
  if (!btn) return;
  e.preventDefault();
const product = {
    id: parseInt(btn.dataset.wishlistBtn),
    title: btn.dataset.title,
    price: btn.dataset.price,
    image: btn.dataset.image,
    url: btn.dataset.url,
    variantId: parseInt(btn.dataset.variantId) || null,
  };

  const added = window.spektraWishlist.toggle(product);

  /* Küçük feedback animasyonu */
  btn.classList.toggle('is-active', added);
  btn.style.transform = 'scale(1.2)';
  setTimeout(() => { btn.style.transform = ''; }, 200);
});





function wishlistAddToCart(variantId, btn, url) {
  if (!variantId || variantId === 'null') {
    window.location.href = url;
    return;
  }
  btn.textContent = '...';
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(r => r.json())
  .then(() => {
   btn.textContent = 'Eklendi ✓';
    setTimeout(() => {
      btn.textContent = 'Sepete At';
      btn.disabled = false;
    }, 1500);
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('theme:cart:add'));
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
  })
  .catch(() => {
    btn.textContent = 'Sepete At';
    btn.disabled = false;
  });
}